// Angular Dependencies
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { ModalHtmlPreviewComponent } from "./modal-html-preview.component";

@NgModule({
	declarations: [ModalHtmlPreviewComponent],
	imports: [
    MatIconModule,
    MatButtonModule
	],
	exports: [ModalHtmlPreviewComponent],
})
export class ModalHtmlPreviewModule {}
